import isExternalURL from '../../../utils/isExternalURL';
import { useAnalyticsPushEvent } from '../../../analytic/analytic.context';
import Icon from '../../Atoms/Icon/Icon';
import bem from '../../../utils/bem';

const IconsBelt = ({
  items,
  vertical,
  grid,
  columns,
  iconWidth = 18,
  iconHeight = 18,
  color = 'grey-dark',
  className,
}) => {
  const pushEvent = useAnalyticsPushEvent();
  if (!items || !items.length) {
    return null;
  }
  const componentClassName = 'm-icons-belt';
  const componentClasses = bem(
    componentClassName,
    [vertical && 'vertical', grid && 'grid'],
    '',
    [color && `text-${color}`, className],
  );
  const componentStyles = {
    ...(grid && columns
      ? {
          gridTemplateColumns: Array.from(
            { length: columns },
            () => '1fr',
          ).join(' '),
        }
      : {}),
  };

  const icons = items.map((item, i) => {
    const analyticsPushEvent = () => {
      if (item.analyticsClickPush) {
        pushEvent(item.analyticsClickPush);
      }
    };

    const ItemContent = () => (
      <span className={bem('element', [], componentClassName)}>
        {item.icon && (
          <Icon iconName={item.icon} width={iconWidth} height={iconHeight} />
        )}
        <span className={bem('text', [], componentClassName)}>{item.text}</span>
      </span>
    );
    return (
      <li
        key={item.text + i}
        className={bem('list-item', [item.type || ''], componentClassName)}
      >
        {item.url ? (
          <a
            className={bem('link', [], componentClassName)}
            href={item.url}
            target={isExternalURL(item.url) ? '_blank' : item.targetAttr}
            onClick={analyticsPushEvent}
          >
            <ItemContent />
          </a>
        ) : (
          <ItemContent />
        )}
      </li>
    );
  });
  return (
    <ul className={componentClasses} style={componentStyles}>
      {icons}
    </ul>
  );
};

export default IconsBelt;
